/**
 * App shell: header, scrollable main, optional bottom tab bar.
 * В Mini App: учёт safe area и уменьшенная высота хедера.
 * На роутах /admin/* показывается AdminTabBar вместо основного TabBar.
 */

import { useLocation } from "react-router-dom";
import { AppHeader } from "./AppHeader.tsx";
import { TabBar } from "./TabBar.tsx";
import { AdminTabBar } from "./AdminTabBar.tsx";
import { isTelegramMiniApp } from "../../lib/telegram.ts";

/** Высота контента хедера в Mini App (без safe-area) */
const MINI_APP_HEADER_CONTENT = 52;

interface LayoutProps {
  children: React.ReactNode;
  showNav?: boolean;
  /** На главной: шире контейнер на десктопе (lg:max-w-5xl) */
  wideOnDesktop?: boolean;
}

export function Layout({ children, showNav = true, wideOnDesktop = false }: LayoutProps) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  const isMiniApp = isTelegramMiniApp();
  const spacerHeight = isMiniApp
    ? `calc(env(safe-area-inset-top, 0px) + ${MINI_APP_HEADER_CONTENT}px + var(--header-offset-buffer))`
    : "calc(env(safe-area-inset-top, 0px) + var(--header-height) + var(--header-offset-buffer))";

  const NavBar = isAdmin ? AdminTabBar : TabBar;

  return (
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden relative z-20">
      <AppHeader />
      <div
        className="shrink-0 w-full"
        style={{ minHeight: spacerHeight }}
        aria-hidden
      />

      <main
        className={`flex-1 min-h-0 overflow-y-auto overflow-x-hidden pt-2 xs:pt-2 lg-mobile:pt-3 ${showNav ? "main-with-tab-bar" : "pb-6"}`}
      >
        <div
          className={`w-full max-w-xl sm:max-w-2xl mx-auto px-3 xs:px-4 min-[430px]:px-5 min-[520px]:px-6 sm:px-7 ${wideOnDesktop ? "lg:max-w-5xl" : ""}`}
        >
          {children}
        </div>
      </main>

      {showNav && <NavBar />}
    </div>
  );
}
